export const SEARCH_RESULT = "Search_Result";
export const SEARCH_COURSE_CARD_CLICK = "Search_Course_Card_Click"